export default __webpack_public_path__ + "static/media/1460.5e90328e.png";